/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  put as putAxios,
  post as postAxios,
} from "../apiHandler";
import { isEmptyObj } from "../../utils/helper";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 5;

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });

export default class Member {
  static transferMember({ data, memberId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/members/${memberId}/transfer`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.transferMember.cancel = request.cancel;
    return request;
  }

  static searchMemberTransferRequests(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/search/transferRequests`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.searchMemberTransferRequests.cancel = request.cancel;
    return request;
  }

  static getPendingTransfer({ pageNumber, pageSize, type }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/members/pendingTransfers?page=${pageNumber}&size=${pageSize}&type=${type}`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Member.getPendingTransfer.cancel = request.cancel;
    return request;
  }

  static forwardMember({ data, memberId, transferRequestId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/transferRequests/${transferRequestId}/forward`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Member.forwardMember.cancel = request.cancel;
    return request;
  }

  static getMemberRemarks({ transferRequestId }) {
    const accessToken = localStorage.getItem("authToken");
    const request = get(`/api/members/${transferRequestId}/remarks`, {
      accessToken,
    });

    Member.getMemberRemarks.cancel = request.cancel;
    return request;
  }

  static cancelMember({ memberId, id }) {
    const accessToken = localStorage.getItem("authToken");
    const request = put(`/api/members/${memberId}/transfers/${id}/cancel`, {
      accessToken,
    });

    Member.cancelMember.cancel = request.cancel;
    return request;
  }

  static acceptMember({ data, memberId, transferRequestId }) {
    const accessToken = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/transferRequests/${transferRequestId}/accept?blockId=${data.blockId}`,
      {
        accessToken,
        data,
      }
    );

    Member.cancelMember.cancel = request.cancel;
    return request;
  }

  static rejectMember({ data, memberId, transferRequestId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/transferRequests/${transferRequestId}/reject `,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Member.rejectMember.cancel = request.cancel;
    return request;
  }

  static addRemarkForMemberTransfer({ data, memberId, transferRequestId }) {
    const accessToken = localStorage.getItem("authToken");
    const request = post(
      `/api/members/${memberId}/transferRequests/${transferRequestId}/remarks`,
      {
        accessToken,
        data,
      }
    );

    Member.addRemarkForMemberTransfer.cancel = request.cancel;

    return request;
  }

  static postNewMember({ data }) {
    const accessToken = localStorage.getItem("authToken");
    const request = post(`/api/members`, {
      data,
      accessToken,
    });

    Member.postNewMember.cancel = request.cancel;
    return request;
  }

  static search(data, params, isSameOrg = true) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post("/api/members/search", {
      accessToken: accessTokenFromLocal,
      data: isEmptyObj(data)
        ? null
        : { ...data, inOrganisationStructure: isSameOrg },
      params: {
        size: params?.pageSize ?? PAGE_SIZE,
        page: params?.page ?? 0,
      },
    });

    Member.search.cancel = request.cancel;
    return request;
  }

  static memberView(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/${data}`, {
      accessToken: accessTokenFromLocal,
    });

    Member.memberView.cancel = request.cancel;
    return request;
  }

  static memberUpdate(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/members`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.memberUpdate.cancel = request.cancel;
    return request;
  }

  static getAttendanceByMemberId(memberId, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/${memberId}/attendance/history`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.getAttendanceByMemberId.cancel = request.cancel;
    return request;
  }

  static getAppointmentsByMemberId(memberId, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/members/${memberId}/appointments?status=RETIRED`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Member.getAppointmentsByMemberId.cancel = request.cancel;
    return request;
  }

  static memberDeactivate({ data, memberId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/members/${memberId}/deactivate`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.memberDeactivate.cancel = request.cancel;
    return request;
  }

  static memberDirectDeactivate({ data, applicationId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/deactivations/applications/${applicationId}/directDeactivate`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Member.memberDirectDeactivate.cancel = request.cancel;
    return request;
  }

  static memberDirectDeactivateWithTransferMemberId({
    data,
    applicationId,
    transferToMemberId,
  }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/deactivations/applications/${applicationId}/directDeactivate`,
      {
        accessToken: accessTokenFromLocal,
        data,
        params: {
          transferToMemberId,
        },
      }
    );

    Member.memberDirectDeactivateWithTransferMemberId.cancel = request.cancel;
    return request;
  }

  static memberReactivate({ data, memberId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/members/${memberId}/reactivate`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.memberReactivate.cancel = request.cancel;
    return request;
  }

  static getRelationshipsByMemberId(memberId, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/${memberId}/relationships`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.getRelationshipsByMemberId.cancel = request.cancel;
    return request;
  }

  static getMemberDetailsById(memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/${memberId}`, {
      accessToken: accessTokenFromLocal,
    });

    Member.getMemberDetailsById.cancel = request.cancel;
    return request;
  }

  static checkAppointmentInProgress(memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/deactivations/applications/check-appointment-inpregress/${memberId}`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Member.checkAppointmentInProgress.cancel = request.cancel;
    return request;
  }

  static getStructureLeadersByName({ fullName, ...params }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/structureLeaders`, {
      accessToken: accessTokenFromLocal,
      data: {
        page: 0,
        size: 5,
        fullName,
        ...params,
      },
    });

    Member.getStructureLeadersByName.cancel = request.cancel;
    return request;
  }

  static getStructure({ id, ...data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/split/structure/${id}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.getStructure.cancel = request.cancel;
    return request;
  }

  static getCurrentAppointmentsByMemberId(memberId, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/${memberId}/currentAppointments`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.getCurrentAppointmentsByMemberId.cancel = request.cancel;
    return request;
  }

  static changeToMember({ data, friendId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/friends/${friendId}/convertToMember`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.changeToMember.cancel = request.cancel;
    return request;
  }

  static structureLeaders(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/structureLeaders`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.structureLeaders.cancel = request.cancel;
    return request;
  }

  static structureLeadersSpecialGroup(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/specialGroup/structureLeaders`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.structureLeadersSpecialGroup.cancel = request.cancel;
    return request;
  }

  static structureLeadersUHG(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/uhg/structureLeaders`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.structureLeadersUHG.cancel = request.cancel;
    return request;
  }

  static uploadProfilePhoto({ memberId, data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    const request = post(`/api/members/${memberId}/profilePhoto`, {
      accessToken: accessTokenFromLocal,
      data,
      headers,
    });

    Member.uploadProfilePhoto.cancel = request.cancel;
    return request;
  }

  static getSubscriptionByMemberId(memberId, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/${memberId}/subscriptions`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.getSubscriptionByMemberId.cancel = request.cancel;
    return request;
  }

  static getMemberPendingTransfer(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/pendingTransfers`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        page: data.page,
        size: data.size,
      },
    });

    Member.getMemberPendingTransfer.cancel = request.cancel;
    return request;
  }

  static searchInduction({ fullName, ...params }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/specialGroups/induction`, {
      accessToken: accessTokenFromLocal,
      data: {
        page: 0,
        size: 5,
        fullName,
        ...params,
      },
    });

    Member.searchInduction.cancel = request.cancel;
    return request;
  }

  static specialGroupMemberSearch({ fullName, ...params }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/specialGroups/members/search`, {
      accessToken: accessTokenFromLocal,
      data: {
        page: 0,
        size: 5,
        fullName,
        ...params,
      },
    });

    Member.specialGroupMemberSearch.cancel = request.cancel;
    return request;
  }

  static getExamByMemberId(memberId, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/${memberId}/exams`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.getExamByMemberId.cancel = request.cancel;
    return request;
  }

  static getAwardByMemberId(memberId, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/${memberId}/awards`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.getAwardByMemberId.cancel = request.cancel;
    return request;
  }

  static CreateAward(data, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/members/${memberId}/awards`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.CreateAward.cancel = request.cancel;
    return request;
  }

  static getDeactivationList({ ...params }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/deactivations/applications`, {
      accessToken: accessTokenFromLocal,
      data: {
        page: 0,
        size: 5,
        ...params,
      },
    });

    Member.getDeactivationList.cancel = request.cancel;
    return request;
  }

  static memberDeactivationVerification({ data, applicationId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/deactivations/applications/${applicationId}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.memberDeactivationVerification.cancel = request.cancel;
    return request;
  }

  static memberDeactivationVerificationWithTransferId({
    data,
    applicationId,
    transferToMemberId,
  }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/deactivations/applications/${applicationId}`, {
      accessToken: accessTokenFromLocal,
      data,
      params: {
        transferToMemberId,
      },
    });

    Member.memberDeactivationVerificationWithTransferId.cancel = request.cancel;
    return request;
  }

  static rejectDeactivation({ data, applicationId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/deactivations/applications/${applicationId}/reject`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Member.rejectDeactivation.cancel = request.cancel;
    return request;
  }

  static transferEligibility({ data, memberId }) {
    const accessToken = localStorage.getItem("authToken");
    const request = post(`/api/members/${memberId}/transferRequests/eligible`, {
      accessToken,
      data,
    });

    Member.transferEligibility.cancel = request.cancel;

    return request;
  }

  static addHdcRequest(memberId, { data }) {
    const accessToken = localStorage.getItem("authToken");
    const request = post(`/api/members/${memberId}/hdc/applications`, {
      accessToken,
      data,
    });

    Member.addHdcRequest.cancel = request.cancel;

    return request;
  }

  static getHdcByMemberId({ memberId, data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/${memberId}/hdc/applications`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.getHdcByMemberId.cancel = request.cancel;
    return request;
  }

  static getGohonzonConsentForMember(memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/gohonzonApplications/consent`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Member.getGohonzonConsentForMember.cancel = request.cancel;
    return request;
  }

  static transferredStructureLeaders(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/transferred/structureLeaders`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Member.transferredStructureLeaders.cancel = request.cancel;
    return request;
  }

  static updateExam({ data, memberId, applicationId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/applications/${applicationId} `,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Member.updateExam.cancel = request.cancel;
    return request;
  }

  static removeExam({ data, memberId, applicationId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/applications/${applicationId}/remove`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Member.removeExam.cancel = request.cancel;
    return request;
  }

  static bulkRoleAuthorization({ data }) {
    const accessToken = localStorage.getItem("authToken");
    const request = post(`/api/roles/bulkAuthorizations`, {
      accessToken,
      data,
    });

    Member.bulkRoleAuthorization.cancel = request.cancel;

    return request;
  }
}
